import { render, staticRenderFns } from "./PageInfoCategories.vue?vue&type=template&id=4b1eadea&"
import script from "./PageInfoCategories.vue?vue&type=script&lang=js&"
export * from "./PageInfoCategories.vue?vue&type=script&lang=js&"
import style0 from "./PageInfoCategories.vue?vue&type=style&index=0&id=4b1eadea&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b1eadea')) {
      api.createRecord('4b1eadea', component.options)
    } else {
      api.reload('4b1eadea', component.options)
    }
    module.hot.accept("./PageInfoCategories.vue?vue&type=template&id=4b1eadea&", function () {
      api.rerender('4b1eadea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/infoCategories/PageInfoCategories.vue"
export default component.exports